import script from "./MemoryOptimized.vue?vue&type=script&setup=true&lang=js"
export * from "./MemoryOptimized.vue?vue&type=script&setup=true&lang=js"

import "./MemoryOptimized.vue?vue&type=style&index=0&id=92255bb4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-92255bb4"]])

export default __exports__